import type { WebhookMapping } from "./webhook-endpoints";

/** Analysis results (preset / LLM) never carry an HQ rule — keep the one the
 *  admin already had in the draft (TASK-233), else saving would delete it. */
export function keepHqRule(next: WebhookMapping, prev: WebhookMapping | null): WebhookMapping {
  if (!prev?.hq_rule || next.hq_rule) return next;
  return { ...next, hq_rule: prev.hq_rule };
}

/** The mapping with only its hq_rule replaced; every other part stays as given. */
export function mappingWithHqRule(mapping: WebhookMapping, rule: unknown): WebhookMapping {
  return { ...mapping, hq_rule: rule };
}
